import React, {useState}  from 'react';
import bluearrow from '../images/blue_arrow.svg';
import whitearrow from '../images/white_arrow.svg';
import { getLeaderBoard } from './helpers/apihandler';
import { LeaderBoardDetails } from './leaderBoardDetails';

function LeaderBoard({weeks}){
const [styleDisplay, setStyleDisplay] = useState([]);
const [weeklyLeaderboard, setWeeklyLeaderboard] = useState([]);
const [seasonLeaderboard, setSeasonLeaderboard] =  useState([]);
    const weekData = weeks;

    const showOrHide = async(x, id, season) => {
        if (styleDisplay[x] === "none" || styleDisplay[x] === undefined){
            let tempstyle = [...styleDisplay];
            if (season === "no"){
                let templeaderboard = [...weeklyLeaderboard];
                if (templeaderboard[id] === undefined ){
                    let tempcurrentlb = await getLeaderBoard(id,"no");
                    templeaderboard[id] = tempcurrentlb;
                }
                setWeeklyLeaderboard(templeaderboard);
                

            }else{
                let tempseasonlb = [...seasonLeaderboard];
                if ( tempseasonlb[season] === undefined ){
                    let tempcurrentseasonlb = await getLeaderBoard(id,"yes");
                    console.log(tempcurrentseasonlb);
                    tempseasonlb[season] = tempcurrentseasonlb;
                }
                setSeasonLeaderboard(tempseasonlb);
            }
            tempstyle[x] = "flex";
            setStyleDisplay(tempstyle);
        }else{
            let tempstyle = [...styleDisplay];
            tempstyle[x] = "none";
            setStyleDisplay(tempstyle);
        }
    }

    return <div><div className='createFormat row' ><div className='col-md-4' style={{fontWeight:'bold', fontSize:'1.1em'}}>Week #:</div><div className='col'>Show / Hide</div><div className='col-md-4' style={{fontWeight:'bold', fontSize:'1.1em'}}>Event Type:</div></div>{weekData.map( function(week, i) {
       return <div key={i} id={'coll' + i.toString()} className='row' style={{paddingLeft:'3%'}} ><div className='col-md-4' style={{fontWeight:'bold', backgroundColor:(i % 2 === 0 ? 'rgba(0, 0, 0, 0.4)' : 'unset'), paddingTop: '1%', paddingBottom: '1%'}} >{week.label}</div><div style={{fontWeight:'bold', display:'inline', backgroundColor:(i % 2 === 0 ? 'rgba(0, 0, 0, 0.4)' : 'unset'), paddingTop: '1%', paddingBottom: '1%'}} className='col'><img src={(styleDisplay[i] !== 'flex' ? bluearrow : whitearrow)} onClick={() => {showOrHide(i, week.id, (week.league === "0" ? "no" : week.season))}} alt="showhide" style={{width:'16px',cursor:'pointer', paddingTop: '1%', paddingBottom: '1%'}} /></div> <div className='col-md-4' style={{backgroundColor:(i % 2 === 0 ? 'rgba(0, 0, 0, 0.4)' : 'unset'), paddingTop: '1%', paddingBottom: '1%'}} >{week.racename}</div><div><LeaderBoardDetails details={(week.league === "0" ? weeklyLeaderboard[week.id] : seasonLeaderboard[week.season])} racetype={week.racetype} styledisplay={styleDisplay[i]} /></div></div>
        
    })}</div>
}

export {LeaderBoard};